import React, { Component } from "react";
import { TouchableHighlight, View } from "react-native";
import Text from "./TextFont";
import { SimpleIcon } from "./Buttons";
import { faSort } from "../../assets/consts/faCharCodes";
import ArTheme from "../argon-ui/Theme";

import PropTypes from "prop-types";

/**@augments{Component<props,state>} */
class SimpleDraggableItem extends Component {
  static propTypes = {
    number: PropTypes.number.isRequired,
    canDrag: PropTypes.bool,
    onDragAreaPress: PropTypes.func,
    onManuallyChange: PropTypes.func,
    isDragging: PropTypes.bool,
  };

  render() {
    return (
      <View
        style={{
          flexDirection: "row",
          // flex: 1,
          alignItems: "center",
          borderColor: ArTheme.COLORS.ERROR,
          borderWidth: this.props.isDragging ? 1 : 0,
          borderRadius: 3,
          backgroundColor: this.props.isDragging
            ? ArTheme.COLORS.INPUT_ERROR
            : "#eee",
        }}
      >
        {this.props.canDrag === true && (
          <TouchableHighlight
            underlayColor="transparent"
            onPressIn={() => {
              typeof this.props.onDragAreaPress === "function" &&
                this.props.onDragAreaPress();
            }}
          >
            <View
              style={{
                flexDirection: "row",
                backgroundColor: "#777",
                justifyContent: "space-between",
                alignItems: "center",
                marginHorizontal: 5,
                padding: 10,
                borderRadius: 10,
                borderColor: "#aaa",
                borderWidth: 1,
                minWidth: 55,
              }}
            >
              <SimpleIcon icon={faSort} size={18} color="#FFF" />
              <Text
                style={{ fontSize: 18, color: "#FFF", marginHorizontal: 5 }}
              >
                {this.props.number}
              </Text>
            </View>
          </TouchableHighlight>
        )}
        <View style={{ flex: 1 }}>{this.props.children}</View>
      </View>
    );
  }
}

export default SimpleDraggableItem;
